export default "/fonts/icon-font.eot?fd106ec836e0987b665364b6b88ca1c7";